
import {
  aemHostClient,
  ejectAEMHostRequestInterceptorRef,
  ejectAEMHostResponseInterceptorRef
} from './aemHostRestClient';

import {
  eapiClient,
  ejectEAPIRequestInterceptorRef,
  ejectEAPIResponseInterceptorRef
} from './eapiRestClient';

import {
  ejecttaxonomyHostRequestInterceptorRef,
  ejecttaxonomyHostResponseInterceptorRef,
  taxonomyHostClient
} from './taxonomyHostRestClient';


export {
  aemHostClient, eapiClient, ejectAEMHostRequestInterceptorRef,
  ejectAEMHostResponseInterceptorRef, ejectEAPIRequestInterceptorRef,
  ejectEAPIResponseInterceptorRef, ejecttaxonomyHostRequestInterceptorRef,
  ejecttaxonomyHostResponseInterceptorRef, taxonomyHostClient
};




// WEBPACK FOOTER //
// ./src/restClient/index.js